module.exports = __webpack_public_path__ + "static/media/SuccessLogo.43932b61.svg";